import React from 'react';

const QuickSightChatAgent = ({ agentId, errorMessage, isLoading }) => {
  return (
    <div className="flex h-full w-full flex-col">
      {errorMessage && (
        <div className="mb-4 shrink-0 rounded-md bg-red-100 p-3 text-sm text-red-700">
          {errorMessage}
        </div>
      )}

      {/* flex-1 + min-h-0 make this fill whatever height the parent
          actually has, instead of a fixed 700px that could be taller or
          shorter than the space available on a given screen. min-h-0 is
          required for a flex child to shrink below its content size —
          without it this would ignore flex-1 and keep forcing 700px anyway. */}
      <div className="relative min-h-0 w-full flex-1">
        {isLoading && !errorMessage && (
          <div className="absolute inset-0 z-10 flex flex-col items-center justify-center gap-3 bg-white">
            {/* Forced onto its own GPU layer (will-change-transform + translateZ)
                so the spin keeps animating even while the QuickSight iframe is
                busy loading and hogging the main thread. Without this, Chrome
                can end up recalculating the rotation on the main thread and the
                spin visibly stalls partway through a long load. */}
            <span
              className="h-8 w-8 will-change-transform animate-spin rounded-full border-2 border-primary-200 border-t-primary-600"
              style={{ transform: 'translateZ(0)' }}
            />
            <p className="text-sm font-medium text-gray-500">
              Connecting to your assistant&hellip;
            </p>
          </div>
        )}

        <div
          id={`quick-chat-${agentId}`}
          className="h-full w-full"
        />
      </div>
    </div>
  );
};

export default QuickSightChatAgent;
